import Panel from "Clutch/Atoms/Panel";
import Gutters from "Clutch/Atoms/Gutters";
import Typography from "Clutch/Atoms/Typography";
import TestCalculator from "./testCalculator";
import EngineDisplacement from "./engineDisplacement";
import CubicInchesToLiters from "./cubicInchesToLiters";
import WheelOffset from "./wheelOffset";
import MmInchesConversion from "./mmInchesConversion";
import FinalTireSizeByWheel from "./finalTireSizeByWheel";
import FinalWheelSizeByTire from "./finalWheelSizeByTire";

const CalculatorLookupTable = [
    {
        calckey: 'test',
        component: TestCalculator,
        title: "Explore Addition"
    },
    {
        calckey: 'engineDisplacement',
        component: EngineDisplacement,
        title: "Engine Displacement"
    },
    {
        calckey: 'cubicInchesToLiters',
        component: CubicInchesToLiters,
        title: "Cubic Inches To Liters"
    },
    {
        calckey: 'wheelOffset',
        component: WheelOffset,
        title: "Wheel Offset"
    },
    {
        calckey: 'mmInchesConversion',
        component: MmInchesConversion,
        title: "MM Inches Conversion"
    },
    {
        calckey: 'finalTireSizeByWheel',
        component: FinalTireSizeByWheel,
        title: "Final Tire Size By Wheel Specs"
    },
    {
        calckey: 'finalWheelSizeByTire',
        component: FinalWheelSizeByTire,
        title: "Final Wheel Size By Tire Specs"
    },
]

const SortingGate = ({ calckey }) => {
    if (CalculatorLookupTable.some(x => x.calckey == calckey)) {
        const CalcToRender = CalculatorLookupTable.find(x => x.calckey == calckey);
        return <>
            <Panel>
                <Gutters>
                    <Typography as={'h2'} size={1.5}>{CalcToRender.title}</Typography>
                    <CalcToRender.component />

                </Gutters>

            </Panel>
        </>
    }
    console.error(`Unkown toolbox calculator: ${calckey}`)
    return false
}

export const GetAllCalculatorKeys = () => {
    return CalculatorLookupTable.map(x => x.calckey)
}

export default SortingGate